// @flow

import { css } from 'styled-components';
import getPadding from './getPadding';
import type { StyledButtonProps } from '../types';
import type { ButtonSchemeName } from '../../../types/theme';

export default (colorScheme: ButtonSchemeName, props: StyledButtonProps) => css`
  color: ${props.theme.buttons.scheme[colorScheme].main};
  border-color: transparent;
  background: transparent;
  padding: ${getPadding(Boolean(props.withIcon), props)};
  ${props.caret && css`
    &:after {
      border-color: ${props.theme.buttons.scheme[colorScheme].main};
    }
  `}

  &:visited {
    color: ${props.theme.buttons.scheme[colorScheme].main};
  }

  &:hover {
    color: ${props.theme.buttons.scheme[colorScheme].hover};
    ${props.caret && css`
      &:after {
        border-color: ${props.theme.buttons.scheme[colorScheme].hover};
      }
    `}
  }

  &:focus,
  &:active {
    color: ${props.theme.buttons.scheme[colorScheme].active};
    ${props.caret && css`
      &:after {
        border-color: ${props.theme.buttons.scheme[colorScheme].active};
      }
    `}
  }
`;
